import moment from "moment";
import config from "appConfig";
import {
  LocaleCode,
} from "../../../models";


const hrTimeConfig = {
  relativeTime: {
    s: "1 min",
    ss: "1 min",
    m: "1 min",
    mm: "%d min",
    h: "1 hr",
    hh: "%d hrs",
    d: "1 dan",
    dd: "%d dana"
  }
};

const enTimeConfig = {
  relativeTime: {
    s: "1 min",
    ss: "1 min",
    m: "1 min",
    mm: "%d mins",
    h: "1 hr",
    hh: "%d hrs",
    d: "1 day",
    dd: "%d days"
  }
};


export const useMomentLocale = () => {

  moment.locale(
    config.localeCode,
    // @ts-ignore
    config.localeCode === LocaleCode.hr ? hrTimeConfig : enTimeConfig
  );

}


// WEBPACK FOOTER //
// ./src/containers/HomePage/hooks/useMomentLocale.ts